// frontend/src/components/auth/ForgotPassword.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authService } from "../../services/auth";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("sending");
    try {
      await authService.requestPasswordReset(email);
      setStatus("sent");
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
      setStatus("idle");
    }
  };

  if (status === "sent") {
    return (
      <div className="login-container">
        <div className="login-box" style={{ textAlign: "center" }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "rgba(46, 125, 50, 0.12)",
              fontSize: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem",
            }}
          >
            📧
          </div>
          <h2>Check your email</h2>
          <p style={{ color: "var(--text-secondary, #666666)", lineHeight: 1.5, marginBottom: "1.5rem" }}>
            If <strong>{email}</strong> is registered, you&apos;ll receive a password reset link shortly.
            Check your spam folder if it doesn&apos;t arrive within a few minutes.
          </p>
          <Link to="/login" className="link-button" style={{ display: "inline-block" }}>
            Back to login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Forgot password</h2>
        <p style={{ color: "var(--text-secondary, #666666)", marginBottom: "1.25rem", lineHeight: 1.5 }}>
          Enter the email address associated with your account and we&apos;ll send you a reset link.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="reset-email">Email</label>
            <input
              id="reset-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              placeholder="your@email.com"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send reset link"}
          </button>
        </form>
        <p className="toggle-form">
          <Link to="/login" className="link-button">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
